<template>
    <div ref="cardShareComponent" v-if="null != shareInfoRef.cardId">
        <shareCardDialog />
    </div>
</template>

<script setup>
    import {onMounted, toRef} from "vue";
    import { useShareinfo } from '@/stores/shareinfo'
    import shareCardDialog from "@/components/shopopee/dialog/shareCardDialog"

    const shareInfoRef = toRef(useShareinfo())

    onMounted(() => {

    })
</script>

<style scoped>

</style>